import { render, staticRenderFns } from "./EMelderComponentRisikoMainTable.vue?vue&type=template&id=7a13bdd8&scoped=true"
import script from "./EMelderComponentRisikoMainTable.vue?vue&type=script&lang=js"
export * from "./EMelderComponentRisikoMainTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a13bdd8",
  null
  
)

export default component.exports